import React from "react";
import { useI18n } from "../i18n";
import ModulesChooser from "../components/ModulesChooser";

/** The owner's own switches: what the shop uses, within what its plan offers. */
const Modules = () => {
  const { t } = useI18n();

  return (
    <div className="max-w-3xl space-y-6">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">{t("modules.title")}</h1>
      <ModulesChooser />
    </div>
  );
};

export default Modules;
